/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Filter_OverdueInputs */

const cs_tasks_filter_overdue = /** @type {(inputs: Tasks_Filter_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po termínu`)
};

const en_tasks_filter_overdue = /** @type {(inputs: Tasks_Filter_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overdue`)
};

/**
* | output |
* | --- |
* | "Overdue" |
*
* @param {Tasks_Filter_OverdueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_filter_overdue = /** @type {((inputs?: Tasks_Filter_OverdueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Filter_OverdueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_filter_overdue(inputs)
	return cs_tasks_filter_overdue(inputs)
});